import React from 'react'
import { LinkButton } from '@chilecompra/react-kit'
import BrandLayout from '../components/Layouts/BrandLayout'
import FooterContainer from '../containers/Footer/Footer.container'
import { LogoCHC, Image404, Root, Text } from './NotFound.styles'

/**
 * The NotFound' page.
 */
const NotFound = () => (
  <BrandLayout footer={<FooterContainer />}>
    <Root>
      <LogoCHC alt="ChileCompra" src="/assets/images/logo-dccp.svg" />
      <Text>La página solicitada no existe</Text>
      <Image404 alt="La página solicitada no existe" src="/assets/images/404.svg" />
      <LinkButton color="primary" to="/">
        Volver al Inicio
      </LinkButton>
    </Root>
  </BrandLayout>
)

export default NotFound
